import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAddPlanzoneResourceToProjectsRequestFailure({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isAddPlanzoneResourceToProjectsRequestPending({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isAddPlanzoneResourceToProjectsRequestSuccess({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
